// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkspaceOverLimitModal_content__aLYpu","text":"WorkspaceOverLimitModal_text__7WS5s","buttons":"WorkspaceOverLimitModal_buttons__2hRbT"};